/* eslint-disable react/jsx-key */
import React from 'react';
import { Modal } from 'antd';

import { Icon } from '..';

import style from './ModalPopup.module.scss';


export const ModalPopup = ({
  title,
  visible,
  onCancel,
  destroyOnClose,
  width,
  icon,
  coloredBackgroud,
  onOk,
  okText,
  okButtonProps,
  cancelText,
  maskClosable = true,
  closable = false,
  footer,
  children,
  noPadding = false,
  dir }) => (
    <Modal
      okText={ okText }
      okButtonProps={ okButtonProps }
      cancelText={ cancelText }
      closable={ closable }
      destroyOnClose={ destroyOnClose }
      maskStyle={ coloredBackgroud && {
          background: 'linear-gradient(to right,#52a237, #1994d4) ',
          opacity: '0.6'
      } }
      width={ width }
      visible={ visible }
      bodyStyle={ noPadding ? { padding: 0 } : null }
      title={
        <span className={ style.title }>
          <Icon svg={ icon } svgProps={{ height: 18, width: 18 }} />
          <h2>
            {title}
          </h2>
        </span>
     }
      onOk={ onOk }
      onCancel={ onCancel }
      footer={ footer }
      maskClosable={ maskClosable }
      dir={ dir }
    >
      {children}
    </Modal>
);
